import { ButtonTheme } from '@philips-emr/tws-constants';

import { DialogService } from './dialog-service';

export interface ParamDialog {
  title?: string;
  description: string;
  onSim: () => void;
  onNao?: () => void;
} 

class StipulatorDialogService {

  public static SN(param: ParamDialog): void {
    const { title, description, onSim, onNao } = param;

    DialogService.open({
      title: title ?? '',
      description,
      dockButtons: [
        {
          title: 'stipulator.nao',
          type: ButtonTheme.QUIET_DEFAULT,
          action: onNao,
        },
        {
          title: 'stipulator.sim',
          type: ButtonTheme.PRIMARY,
          action: onSim,
        },
      ],
    });
  }
}

export {
  StipulatorDialogService,
};
